import { Theme, Components } from '@mui/material';

export const MuiCssBaseline: Components<
  Omit<Theme, 'components'>
>['MuiCssBaseline'] = {
  styleOverrides: (theme: Theme) => {
    return `
    @font-face {
      font-family: 'Rubik';
      font-style: normal;
      font-weight: 400;
      src: url('/fonts/Rubik/Rubik-Regular.ttf') format('truetype');
      font-display: swap;
      line-height: 1.5;
      letter-spacing: 0.15px;
    }
    
    @font-face {
      font-family: 'Rubik';
      font-style: normal;
      font-weight: 500;
      src: url('/fonts/Rubik/Rubik-Medium.ttf') format('truetype');
      font-display: swap;
      line-height: 1.5;
      letter-spacing: 0.15px;
    }
    
    @font-face {
      font-family: 'Rubik';
      font-style: normal;
      font-weight: 700;
      src: url('/fonts/Rubik/Rubik-Bold.ttf') format('truetype');
      font-display: swap;
      line-height: 1.5;
      letter-spacing: 0.15px;
    }

    .shimmer {
      background: ${theme.palette.mode === 'light' ? 'linear-gradient(to right, #f6f6f6 8%, #f0f0f0 18%, #f6f6f6 33%)' : 'linear-gradient(to right, #3a3a3a 8%, #3f3f3f 18%, #4a4a4a 33%)'};
      background-size: 1000px 100%;
      animation: shimmer 2.2s linear infinite forwards;
    }
    
    .shimmer-table-row {
      background: ${theme.palette.mode === 'light' ? theme.palette.common.white : theme.palette.surface.surface};
    }
    .shimmer-table-row--header {
      background-color: transparent;
      box-shadow: none;
      margin: 0;
    }

  /* 
    Styling for Jodit Editor
    These styles are specifically for the Jodit Editor interface
    and its components like the container, toolbar, and workplace.
  */

    .jodit {
      .jodit-popup__content {
        background: ${theme?.palette?.surfaceContainer.high} !important;
        border-radius: 4px;
      }
      .jodit-color-picker__native {
        display: none;
      }
      .jodit-ui-button:hover {
        background: none;
        border: 1px solid ${theme.palette?.primary?.main};
      }
        .jodit-ui-button__text {
        color: ${theme?.palette?.surface.onSurface};
      }
        .jodit-ui-button_variant_outline {
        border: ${theme.palette?.surfaceContainer.container};
      }
    }

    .jodit-container {
      display: flex !important;
      width: 100%;
      height: 100%;
      flex-direction: column !important;
      .jodit-workplace {
        order: 0;
        flex: 1;
      }
      .jodit-toolbar__box:not(:empty) {
      order: 1;
      }
    }
    .jodit-toolbar-button__trigger svg {
      fill: ${theme.palette.surface.onSurfaceVar} !important;
    }
    .jodit-toolbar-button__button:hover {
      background: ${theme.palette.surfaceContainer.lowest} !important;
    }
      .jodit-toolbar-button__icon {
       .jodit-icon {
       fill: ${theme.palette.surface.onSurfaceVar} ;
       stroke: none !important;
    }
      }
   
    .jodit-workplace {
      border-top-left-radius: 3px !important;
      border-top-right-radius: 3px !important;
      background: ${theme.palette.surfaceContainer.lowest} !important;
    }
    .jodit-wysiwyg {
      padding: 16px !important;
      background: ${theme.palette.surfaceContainer.lowest} !important;
      color: ${theme.palette.surface.onSurfaceVar} !important;
      font: ${theme.typography.fontFamily};
      size: 12px;
      line-height: 1.5em;
      p {
        margin-block-start: 0em !important;
        margin-block-end: 0em !important;
      }
      ul {
        margin-block-start: 0em !important;
        margin-block-end: 0em !important;
    }
    }
    .jodit-toolbar__box:not(:empty) {
      background: ${theme.palette.surfaceContainer.container} !important;
      border: none !important;
      border-radius: 0px !important;
      border-bottom-left-radius: 3px !important;
      border-bottom-right-radius: 3px !important;

      .jodit-toolbar-editor-collection:after {
        background: ${theme.palette.surfaceContainer.container} !important;
      }
    }
   .jodit {
      border: 1px solid ${theme.palette.surface.outlineVariant} !important;
      border-radius: 4px !important;
    }
   .jodit-status-bar {
      display: none !important;
    }
  },
  `;
  },
};
